import React from 'react';
import s from './ContinueButton.scss';
import flechaContinuar from '../../../assets/images/Flecha_continuar.svg';

const ContinueButton = ({ onClick, type = "submit", delay, disabled, sticky, children, name, staff}) => (
    <div style={{ animationDelay: delay, display: 'flex', justifyContent: 'center' }} className={(sticky) ? s.footerSticky : s.footer} name={name} >
        <button onClick={onClick} type={type} data-staff={staff} disabled={disabled} name = {name} className={(disabled) ? s.buttonGrey : s.button}>
            {(children)? children : 'Continuar'}
        </button>
    </div>
);

export default ContinueButton;
